export default __webpack_public_path__ + "static/media/settings.94c91ab1.svg";